import React from "react";
import classNames from "classnames";
import { PriceDisplayType } from "../../types";
import { TriangleDown, TriangleUp } from "../../icons";

interface PriceDisplayProps {
  label?: string;
  price: number;
  variant?: PriceDisplayType;
  isRising?: boolean;
  containerClassName?: string;
}
const PriceDisplay: React.FC<PriceDisplayProps> = ({
  label,
  price,
  variant = "standard",
  isRising,
  containerClassName,
}) => {
  return variant === "fluctuating" ? (
    <div
      className={classNames("flex flex-col items-center", containerClassName)}
    >
      <p className="text-[24px] text-auctionMid">{label || "current price"}</p>
      <div className="flex flex-row font-bold text-[64px]">
        {"$" + price}
        <div className="flex gap-y-[10px] flex-col self-center ml-[13px]">
          <TriangleUp fill={isRising ? "black" : "#CCCCCC"} />
          <TriangleDown fill={isRising ? "#CCCCCC" : "black"} />
        </div>
      </div>
    </div>
  ) : (
    <div
      className={classNames("flex flex-col items-center", containerClassName)}
    >
      <p className="text-[24px] text-auctionMid">{label || "current price"}</p>
      <div className="flex flex-row font-bold text-[34px] ">{"$" + price}</div>
    </div>
  );
};

export default PriceDisplay;
